// Vuex
import store from '@/store.js'
// i18n
import i18n from '@/i18n'
// Self-made Snackbar
import snackbar from '@/plugins/snackbar'

import request_configs from './request_configs'
import Request from './request'
import consts from '@/consts.js'

async function imports(data, file) {
  // 导入
  store.dispatch('fullscreenLoading')
  const response = await Request(
    'post',
    'api/orders/import',
    Object.assign({}, data, {
      excel: file
    })
  )
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Import.success', i18n.t('Order.title')))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

async function fetch(data) {
  return Request('get', 'api/orders/', data)
}

async function approval(data) {
  return Request('get', 'api/orders/approval', data)
}

async function exports(data) {
  // 导出报表
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/orders/export', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

async function detailExports(id) {
  // 导出订单报表
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/orders/detail-export/'+id)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

async function freightExport(data) {
  // 导出运费统计报表
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/orders/freight-export',data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

async function batchDetailExport(data) {
  // 批量导出报表
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/orders/batch-detail-export', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

async function fetchOne(id, data) {
  // 获取单个
  return Request('get', 'api/orders/' + id, data)
}

async function fetchRelations(id, data) {
  // 获取订单相关单据
  return Request('get', 'api/orders/' + id + '/relations', data)
}

function delSomeFields(data) {
  // 去除过多杂项
  data = JSON.parse(JSON.stringify(data)) // 深拷贝避免修改原数据
  delete data.actions
  delete data.shop
  delete data.order_activities
  delete data.bill
  delete data.creater
  delete data.modifier
  delete data.account_user
  data.combine_details = data.order_combine_details
  delete data.order_combine_details
  return data
}

async function addPreview(data) {
  // 新建订单预览
  data = delSomeFields(data) // 去除过多杂项
  return Request('post', 'api/orders/add-view', data)
}

async function confirmPreview(data) {
  // 确认订单预览
  data = delSomeFields(data) // 去除过多杂项
  return Request('patch', 'api/orders/confirm-view/' + data.id, data)
}

async function editPreview(data) {
  // 编辑订单预览
  data = delSomeFields(data) // 去除过多杂项
  return Request('patch', 'api/orders/edit-view/' + data.id, data)
}

async function add(data) {
  // 新建订单
  data = delSomeFields(data) // 去除过多杂项
  return Request('post', 'api/orders/add', data)
}

async function confirm(data) {
  // 确认订单
  data = delSomeFields(data) // 去除过多杂项
  return Request('patch', 'api/orders/confirm/' + data.id, data)
}

async function edit(data) {
  // 编辑订单
  data = delSomeFields(data) // 去除过多杂项
  return Request('patch', 'api/orders/edit/' + data.id, data)
}

async function redeliver(id) {
  // 重新分发订单
  return Request('get', 'api/orders/redeliver/' + id)
}

async function approve(id) {
  // 审核订单
  return Request('get', 'api/orders/approve/' + id)
}

async function cancel(id) {
  // 作废订单
  return Request('get', 'api/orders/cancel/' + id)
}

async function revokeCancel(id) {
  // 取消作废订单
  return Request('get', 'api/orders/revoke-cancel/' + id)
}

async function orderToDistributionPrint(id) {
  // 预打印配送单
  return Request('get', 'api/orders/order-to-distributions-print/' + id)
}

async function ordersToDistributionPrint(data) {
  // 批量预打印配送单
  data.limit = consts.limitAll //获取全部
  data.itemsPerPage = consts.limitAll //获取全部
  return Request('get', 'api/orders/orders-to-distributions-print/', data)
}
async function orderPrint(id) {
  //要货单打印
  return Request('get', 'api/orders/order-print/' + id)
}
async function ordersPrint(data) {
  //要货单批量打印
  data.limit = consts.limitAll //获取全部
  data.itemsPerPage = consts.limitAll //获取全部
  return Request('get', 'api/orders/orders-print/', data)
}

async function batchConfirm(data) {
  //批量确认
  return Request('get', 'api/orders/batch-confirm', data, false, false, true)
}

async function batchCancel(data) {
  //批量作废
  return Request('get', 'api/orders/batch-cancel', data, false, false, true)
}

async function batchApprove(data) {
  //批量审批
  return Request('get', 'api/orders/batch-approve', data, false, false, true)
}

async function importFilesByBuyer(shopId, file) {
  //买家导入
  var data = new FormData()
  data.append('excel', file)
  return Request('post', 'api/orders/buyer-import?shop_id=' + shopId, data)
}

async function importFiles(type, shopId, file) {
  //导入
  var data = new FormData()
  data.append('excel', file)
  if (type == 1 || type == 4) {
    if (type == 4) { 
      data.append('auto_flg', 1)
    }
    return Request('post', 'api/orders/import', data)
  } else if (type == 2 && shopId) {
    return Request('post', 'api/orders/buyer-import?shop_id=' + shopId, data)
  } else if (type == 3) {
    return Request('post', 'api/orders/other-import', data)
  }
}

async function thirdAPIViewOrder(data, thirdAccessToken) {
  var headers = []
  if (thirdAccessToken) headers['access-token'] = thirdAccessToken

  return Request(
    'post',
    request_configs.FengpuURL + 'ent/orders/view',
    data,
    false,
    false,
    false,
    headers
  )
}

async function thirdAPIUploadInvoiceImg(file, folder_type, thirdAccessToken) {
  var data = new FormData()
  data.append('image', file)
  data.append('folder_type', folder_type ? folder_type : 'orders')
  data.append('thumbnail', 0)

  var headers = []
  if (thirdAccessToken) headers['access-token'] = thirdAccessToken

  return Request(
    'post',
    request_configs.FengpuURL + 'ent/orders/fapiao-upload',
    data,
    false,
    false,
    false,
    headers
  )
}

async function thirdAPISaveInvoiceImg(data, thirdAccessToken) {
  var headers = []
  if (thirdAccessToken) headers['access-token'] = thirdAccessToken

  return Request(
    'post',
    request_configs.FengpuURL + 'ent/orders/fapiao-save',
    data,
    false,
    false,
    false,
    headers
  )
}

async function update(data) {
  return Request('post', 'api/orders/update', data)
}

async function saveExpress(data) {
  return Request('post', 'api/orders/edit_express_price', data)
}

async function saveDiscount(data) {
  return Request('post', 'api/orders/edit-order-discount', data)
}

async function updateOrdersExtras(orderId, data) {
  return Request('post', 'api/orders/update-orders-extras/' + orderId, data)
}

async function getPricingMaterials(data) {
  return Request('get', 'api/orders/get-pricing-materials', data)
}

async function getPricingOrders(data) {
  if (!data) data = {};
  data.limit = consts.limitAll; // 获取全部
  data.itemsPerPage = consts.limitAll // 获取全部
  data.page = 1;
  return Request('get', 'api/orders/get-pricing-orders', data)
}

async function orderPricing(data) {
  return Request('post', "api/orders/order-pricing", data);
}

async function orderPricingTemplateExport(data) {// 导出批量核价信息
  store.dispatch("fullscreenLoading");
  const response = await Request('get', "api/orders/order-pricing-template-export", data);
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t("Export.recordedHint"));
  }
  store.dispatch("fullscreenLoadingStop");
  return response;
}

async function orderPricingImport(file) {// 导入批量核价
  var data = new FormData();
  data.append("excel", file);
  return Request('post', "api/orders/order-pricing-import", data);
}

export default {
  imports,
  fetch,
  exports,
  approval,
  fetchOne,
  fetchRelations,
  addPreview,
  add,
  confirmPreview,
  confirm,
  editPreview,
  edit,
  redeliver,
  approve,
  cancel,
  revokeCancel,
  orderToDistributionPrint,
  ordersToDistributionPrint,
  orderPrint,
  ordersPrint,
  batchConfirm,
  batchCancel,
  batchApprove,
  importFilesByBuyer,
  importFiles,
  update,
  thirdAPIViewOrder,
  thirdAPIUploadInvoiceImg,
  thirdAPISaveInvoiceImg,
  saveExpress,
  saveDiscount,
  detailExports,
  batchDetailExport,
  freightExport,
  updateOrdersExtras,
  getPricingMaterials,
  getPricingOrders,
  orderPricing,
  orderPricingTemplateExport,
  orderPricingImport,
}
